export default "__VITE_ASSET__B6Bx85am__"